import { CSSProperties } from "react";
import { Options, Localization } from "material-table/types";

export const headerStyle: CSSProperties = {
  backgroundColor: "#FFF",
  borderBottom: "2px solid #000",
  flexDirection: "column",
  paddingRight: "0.5rem",
  paddingLeft: "0.5rem",
};

const rowHeight = "90px";

const rowStyle: CSSProperties = {
  height: rowHeight,
};

export const cellStyle: CSSProperties = {
  overflow: "visible",
  height: "auto",
  fontSize: "0.9rem",
  paddingRight: 0,
  paddingLeft: 0,
  lineHeight: 1,
};

const actionsCellStyle: CSSProperties = {
  paddingLeft: 0,
};

export const cellWidths = {
  brandName: 136,
  brandCompanies: 155,
  routesOfAdministration: 120,
  mechanismsOfAction: 170,
  indications: 188,
  stages: 119,
  submissionTypes: 92,
  view: 85,
};

export const options: Options<any> = {
  actionsColumnIndex: -1,
  padding: "dense",
  thirdSortClick: false,
  pageSize: 50,
  pageSizeOptions: [25, 50, 100, 150, 200],
  maxBodyHeight: "100%",
  emptyRowsWhenPaging: false,
  filtering: false,
  headerStyle,
  rowStyle,
  actionsCellStyle,
  detailPanelColumnAlignment: "left",
  tableLayout: "fixed",
  search: true,
  debounceInterval: 300,
  sorting: true,
};

export const localization: Localization = {
  header: {
    actions: "",
  },
  toolbar: {
    searchPlaceholder: "Quick Filter",
  },
};
